import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="subject-cohort-alias-form"
// Switches the per-cohort alias form between creating a new alias and editing an existing one.
export default class extends Controller {
  static targets = ["form", "input", "method", "submit", "cancel"]
  static values = { createUrl: String }

  edit(event) {
    event.preventDefault()
    const { url, name } = event.params

    this.clearActiveRow()
    this.activeRow = event.currentTarget.closest("tr")
    this.activeRow.classList.add("table-active")

    this.formTarget.action = url
    this.methodTarget.disabled = false
    this.inputTarget.value = name
    this.setSubmitLabel("Save")
    this.cancelTarget.hidden = false
    this.inputTarget.focus()
    this.inputTarget.select()
  }

  cancel(event) {
    event.preventDefault()
    this.clearActiveRow()

    this.formTarget.action = this.createUrlValue
    this.methodTarget.disabled = true
    this.inputTarget.value = ""
    this.setSubmitLabel("Submit")
    this.cancelTarget.hidden = true
  }

  setSubmitLabel(label) {
    this.submitTarget.value = label
    this.submitTarget.dataset.disableWith = label
  }

  clearActiveRow() {
    this.activeRow?.classList.remove("table-active")
    this.activeRow = null
  }
}
